export const ConfigTypes = [
  {id: "FAQ_LAST_UPDATED_AT", name: "FAQ_LAST_UPDATED_AT"},
  {id: "DB_MIGRATION_VERSION", name: "DB_MIGRATION_VERSION"},
  {id: "SHADOW_EMAIL", name: "SHADOW_EMAIL"},
];
